import png1 from "./6.jpg";
import png2 from "./7.jpg";
import png3 from "./8.jpg";
import png4 from "./9.jpg";
import png5 from "./10.jpg";
export const gpjsyh = [
  {
    name: "查找流水",
    msgList: [
      { msg: "登录建设银行APP，搜索【流水明细打印】或【历史明细】" },
      { imgs: [png1, png2] },
    ],
  },
  {
    name: "发送账单",
    msgList: [
      { msg: "选择时间范围【近一年】，填写专属邮箱并发送" },
      { imgs: [png3, png4, png5] },
    ],
  },
  {
    name: "注意事项",
    msgList: [{ msg: "请确认账期覆盖近12个月，并开启明细文件加密" }],
  },
];
